export const description =
  "L'isolation du plancher bas (cave, vide sanitaire) supprime 7 à 10 % des déperditions. Aides cumulables MaPrimeRénov’ + Prime CEE + éco-PTZ + TVA 5,5 % 2026.";
